import {
  project1_300,
  project2_300,
  project3_300,
  project4_300,
  project5_300,
  project6_300,
  project7_300,
  project8_300,
  project9_300,
  project10_300,
  project11_300,
  project12_300,
  project13_300,
  project14_300,
  project15_300,
  project1,
  project2,
  project3,
  project4,
  project5,
  project6,
  project7,
  project8,
  project9,
  project10,
  project11,
  project12,
  project13,
  project14,
  project15,
} from '../images/index.js';

//import thumb1 from '../images/showprojects/project1.jpg';
//import thumb2 from '../images/showprojects/project2.jpg';
const projectsData = [
  // Project 1 - Tax Reporting
  {
    title1: 'Oracle EPM Cloud',
    title2: 'Administering Tax Reporting',
    image: project1,
    thumbImage: project1_300,
    product: 'Oracle Enterprise Performance Management Cloud',
    ePMBusinessProcess: 'EPM - Tax Reporting',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '20',
    noOfSlides: '650+',
    noOfLabActivities: '45+',

    lessonDetails: [
      {
        lessonTitle: 'Introduction to Tax Reporting',
        objectives: [
          'EPM Cloud Service',
          'Tax Reporting Overview',
          'Tax Provision Process',
          'Country-by-Country Reporting',
        ],
      },

      {
        lessonTitle: 'Tax Reporting - Additional Features',
        objectives: [
          'Supplemental Data',
          'Supplemental Data Management',
          'Task Manager',
          'Data Management',
          'Design and Implementation - Best Practices',
          'Modern Tax Reporting Considerations',
        ],
      },
      {
        lessonTitle:
          ' Configure Tax Reporting Business Process    Configure Tax Reporting',
        objectives: [
          'Create a Sample Application',
          'Create a New Application',
          'View Application Properties',
          'Switch a Business Process',
        ],
      },
      {
        lessonTitle: 'Navigating Tax Reporting',
        objectives: [
          'Explore Home Page',
          'Explore Cards',
          'Explore Clusters',
          'Manage Navigation Flows',
        ],
      },
      {
        lessonTitle: 'Set Up Tax Reporting Dimensions',
        objectives: [
          'Dimensions Overview',
          'Dimension Editor',
          'Set Up Jurisdiction',
          'Set Up Currency',
          'Set Up Entities',
          'Create Alternate Hierarchy',
          'Set Up Accounts',
          'Set Up Scenario',
          'Refresh Database',
        ],
      },

      {
        lessonTitle: 'Manage Metadatas',
        objectives: [
          'Metadata Overview',
          'Metadata Load Options',
          'Import Metadata',
          'Export Metadata',
          'Data Management',
          'Enterprise Data Management',
        ],
      },

      {
        lessonTitle: 'Tax Automation Overview',
        objectives: [
          'Data Source Dimension',
          'Forms Overview',
          'Execution Logic',
          'National Tax Automation',
          'Consolidation Overview',
          'Return to Accrual Overview',
          'Tax Account Rollforward',
        ],
      },

      {
        lessonTitle: 'Manage Security',
        objectives: [
          'Security',
          'Manage Artifact Data Access',
          'Cell-Level Security',
        ],
      },

      {
        lessonTitle: 'Load Data Using Data Management',
        objectives: [
          'Data Management Overview',
          'Configure Profile Settings',
          'Register Source System',
          'Register Target Application',
          'Import Format',
          'Define Location',
          'Period and Category Mapping',
          'Load Data',
        ],
      },

      {
        lessonTitle: 'Manage Data',
        objectives: [
          'Data Load Overview',
          'Manage Data',
          'Import Data',
          'Import Data Methods',
          'Import Data Options',
          'Export Data Options',
          'Copy Data',
          'Clear Data',
          'EPM Automate Overview',
          'EST API Overview',
        ],
      },

      {
        lessonTitle: 'Manage Forms',
        objectives: [
          'Forms Overview',
          'Create Form',
          'Data Entry',
          'Manage Forms',
          'Smart List',
          'Variables',
          'Dashboard',
        ],
      },

      {
        lessonTitle: 'Define Valid Intersections',
        objectives: [
          'Valid Intersection Overview',
          'Manage Valid Intersection',
          'Invalid Intersection Report',
          'Valid Intersection in Forms',
        ],
      },

      {
        lessonTitle: 'Data Consolidation',
        objectives: [
          'Data Consolidation',
          'Translation',
          'Ownership Management',
          'Parent Tax Calculation',
          'Intercompany Eliminations',
        ],
      },

      {
        lessonTitle: 'Manage Approval Process',
        objectives: [
          'Approval Process',
          'Approval Unit',
          'Manage Approvals',
          'Export/Import Approval Unit Hierarchies',
          'Approval Unit Reports',
          'Lock and Unlock Entities',
        ],
      },

      {
        lessonTitle: 'Perform Rollovers and Copy Configurations',
        objectives: [
          'Rollover',
          'Rollover by Entity',
          'Copy Configuration',
          'Copy Configuration By Entity',
          'Override Opening Balance',
        ],
      },

      {
        lessonTitle: 'Manage Jobs and Configure Audit',
        objectives: [
          'Jobs Overview',
          'Create Job',
          'Jobs Console',
          'Schedule Jobs',
          'Audit Overview',
          'Task Manager Audit',
        ],
      },

      {
        lessonTitle: 'Migrate Artifacts and Data',
        objectives: [
          'Migration Overview',
          'Snapshot Overview',
          'Backup Snapshot',
          'Export Snapshot',
          'Download Snapshot',
          'Import Snapshot',
          'Delete Snapshot',
          'Migration Reports',
          'Snapshot Modification History',
        ],
      },

      {
        lessonTitle: 'Task Manager',
        objectives: [
          'Task Manager Overview',
          'Prerequisites to Create Tasks',
          'Task Types',
          'Task Templates',
          'Tasks',
          'Schedule',
        ],
      },

      {
        lessonTitle: 'Manage Supplemental Data',
        objectives: [
          'Supplemental Data Manager Overview',
          'Supplemental Data Form',
          'Dimensions',
          'Collection Interval',
          'Data Collection Periods',
          'Collections',
          'Form Templates',
          'Deploy Form Template',
          'Data Entry',
        ],
      },

      {
        lessonTitle: 'Set Up CbCR Automation',
        objectives: [
          'CbCR Overview',
          'CbCR Automation',
          'CbC Reporting Process',
          'Data Entry Overview',
          'Summary Report Overview',
          'Filing CbC Reports',
          'Risk Assessment Dashboard',
          'Data Status',
          'Set Up Approvals for CbCR',
          'CbCR Automation Migration',
        ],
      },
    ],
  },

  // Project 2 - Administer Profitability and Cost Management
  {
    title1: 'Oracle EPM Cloud',
    title2: 'Administer Profitability and Cost Management',
    image: project2,
    thumbImage: project2_300,
    product: 'Oracle Enterprise Performance Management Cloud',
    ePMBusinessProcess: 'EPM - Profitability and Cost Management',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '12',
    noOfSlides: '400+',
    noOfLabActivities: '60+',

    lessonDetails: [
      {
        lessonTitle: 'EPM Cloud Service Overview',
        objectives: [
          'EPM Cloud Service Overview',
          'EPM Standard and Enterprise Cloud Service',
          'Business Processes',
          'Configuring Profitability and Cost Management',
          'EPM Help Center',
          'EPM Client Tools',
        ],
      },

      {
        lessonTitle: 'Profitability and Cost Management Overview',
        objectives: [
          'Profitability and Cost Management Overview',
          'Home Page Interfacee',
          'Application Console',
          'Analytics and Reports',
          'Model Overview',
          'Tools Overview',
          'Explore Repository',
          'Academy',
          'Client Interface Components',
        ],
      },
      {
        lessonTitle: 'Application Overview',
        objectives: [
          'Profitability and Cost Management Application',
          'Dimensions Overview',
          'Dimensions in PCM',
          'Dimensions Managementt',
          'Job Library',
          'EPM Client TooPCM Application Best Practicels',
        ],
      },
      {
        lessonTitle: 'Getting Started with Smart View',
        objectives: [
          'Smart View',
          'Smart View Components',
          'Smart View Ribbon',
          'Data and Data Cells',
          'Functions',
          'Query',
        ],
      },
      {
        lessonTitle: 'Create Rule and Rule Set',
        objectives: [
          'Rule and Rules Set Overview',
          'Create Rule Set',
          'Create Allocation Rule',
          'Create Custom Calculation Rule',
          'Designer Screen Overview',
          'Calculation Rules Screen Overview',
        ],
      },

      {
        lessonTitle: 'Manage Allocations',
        objectives: [
          'Understanding Allocations',
          'Model Views',
          'Model Validation',
          'Calculation',
          'Calculation Screen',
          'Execution Control Screen',
          'Rule Balancing',
          'Allocation Trace',
        ],
      },
      {
        lessonTitle: 'Getting Started with Reporting Web Studio',
        objectives: [
          'Reporting Web Studio Overview',
          'Report Designer',
          'Report Objects',
          'Manage Reports',
          'Books',
        ],
      },
      {
        lessonTitle: 'Working with Financial Reporting',
        objectives: [
          'Explore Repository Overview',
          'Managing Files and Folders',
          'Preferences',
          'Annotations',
          'Design and Schedule Batches',
          'Functions',
          'Administrative Tasks',
        ],
      },
      {
        lessonTitle: 'Profitability and Cost Management Analytics',
        objectives: [
          'Analytics Overview',
          'Intelligence',
          'Dashboard',
          'Queries',
          'Reports',
        ],
      },
      {
        lessonTitle: 'epmautomate',
        objectives: [
          'epmautomate Overview',
          'Setup and Configure epmautomate',
          'Prerequisites',
          'Exit Code',
          'epmautomate Command',
          'epmautomate Script',
        ],
      },
      {
        lessonTitle: 'Cloud Administration',
        objectives: [
          'Understand Security Model',
          'Deploying Database',
          'System Reports',
          'Migration of Application and Artifacts',
          'Migration Reports',
        ],
      },
      {
        lessonTitle: 'Data Management',
        objectives: [
          'Data Management Overview',
          'Configure Data Management',
          'Configure Security Setting',
          'Register Source System',
          'Register Target Application',
          'Configure Import Format',
          'Define Location',
          'Period and Category Mapping',
          'Load Data',
        ],
      },
    ],
  },

  //Project 3 - Create and Manage Reports in Narrative Reporting
  {
    title1: 'Oracle EPM Cloud',
    title2: 'Create and Manage Reports in Narrative Reporting',
    image: project3,
    thumbImage: project3_300,
    product: 'Oracle Enterprise Performance Management Cloud',
    ePMBusinessProcess: 'EPM - Narrative Reporting',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables:
      'Instructor Presentation Slide Deck, \
                   Student Hands on Lab Guide, \
                   Learning Content in Video Format with narration script',
    noOfLessons: '11',
    noOfSlides: '300+',
    noOfLabActivities: '30+',

    lessonDetails: [
      {
        lessonTitle: 'Enterprise Performance Management Cloud Service Overview',
        objectives: [
          'Enterprise Performance Management (EPM) Cloud Service Overview',
          'EPM Standard and Enterprise Cloud Service Overview',
          'Business Processes in EPM  Cloud Service',
          'EPM Help Center',
          'EPM Client Tools',
          'Switching to a Different Business Process',
        ],
      },

      {
        lessonTitle: 'Getting started with Narrative Reporting',
        objectives: [
          'Overview of Narrative Reporting',
          'Narrative Reporting Home Page',
          'Report Package and its Components',
          'Management Report Overview',
          'Overview of the Library and Artifacts',
          'Overview of Smart View',
          'Disclosure Management Overview',
          'Security Levels',
        ],
      },

      {
        lessonTitle: 'Environment Setup',
        objectives: [
          'Install Tools and Sample Data Source',
          'Sample Content Overview',
          'Data Source',
          'Understanding the Dimensions',
          'Security and Roles',
          'Managing Users',
        ],
      },
      {
        lessonTitle: 'Introduction to Report Package',
        objectives: [
          'Report Package Overview',
          'Report Package and Components',
          'Sample Report Package',
          'Defining Style',
          'Create Report Package',
        ],
      },
      {
        lessonTitle: 'Report Package Development Process',
        objectives: [
          'Report Package Content',
          'Report Package Development Process',
          'Report Package Variables',
        ],
      },
      {
        lessonTitle: 'Designing Management Reports',
        objectives: [
          'Management Reporting Components',
          'Design Considerations',
          'Data Source',
          'Report Designer',
          'Working with Grid',
        ],
      },
      {
        lessonTitle: 'Management Report Objects',
        objectives: [
          'Working with Text Boxes',
          'Working with Images',
          'Working with Notes',
          'Working with Charts',
          'Conditional Formatting and Suppressions in Grid',
          'Zooming on Parent Members in Grid',
          'Grouping Dimensions in Grid',
          'Drill to content in Grid',
          'Mathematical Functions',
        ],
      },
      {
        lessonTitle: 'Organizing and Distributing Books, Reports',
        objectives: [
          'Books Overview',
          'Create Book',
          'Book Designer',
          'Bursting',
        ],
      },
      {
        lessonTitle: 'Getting Started with Smart View',
        objectives: [
          'Introduction to Smart View',
          'Install Smart View',
          'Smart View Components',
          'Smart View Ribbon',
          'Data Source Connection',
          'Data and Data Cells',
          'Smart Form',
          'Functions',
        ],
      },
      {
        lessonTitle: 'Disclosure Management',
        objectives: [
          'Introduction to Disclosure Management',
          'Smart View Extensions',
          'Disclosure Management Ribbon',
          'Disclosure Management Components',
          'Disclosure Management Report',
          'Publish Disclosure Management Report',
        ],
      },
      {
        lessonTitle: 'System Administration',
        objectives: [
          'Security',
          'Access Grants',
          'Audit',
          'Migrate Artifacts and Folders',
          'File Transfer Utility',
        ],
      },
    ],
  },

  // Project 4 - Oracle EPM Cloud: Planning

  {
    title1: 'Oracle EPM Cloud',
    title2: 'Planning - Certification Gap',
    image: project4,
    thumbImage: project4_300,
    product: 'Oracle Enterprise Performance Management Cloud',
    ePMBusinessProcess: 'EPM - Planning',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '3',
    noOfSlides: '180+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Free Form Application',
        objectives: [
          'Create Planning Application',
          'Create Free Form Application',
          'Create Free Form Application - Source OTL File',
          'Create Free Form Application - Source Snapshot',
          'Important Consideration - OTL and Snapshot import',
          'Planning Hybrid BSO and ASO Reporting Cube',
        ],
      },

      {
        lessonTitle:
          'Oracle EPM Cloud: Planning: Leverage best practices for Financials',
        objectives: [
          'Introduction to EPM Planning',
          'Planning Financials',
          'KPIs in Planning Financials',
          'Leveraging KPIs in Planning Financials',
          'Leveraging Financials Rules',
          'Planning - Workforce',
          'Planning - Projects',
          'Planning - Capital',
          'Planning - Strategic Modelling',
        ],
      },

      {
        lessonTitle: ' Setting up Strategic Modeling',
        objectives: [
          'Strategic Modeling - Managing Sub Accounts',
          'Strategic Modeling - Set Up Funding Options',
          'Strategic Modeling - Create Scenarios',
          'Strategic Modeling - Manage Time Periods',
        ],
      },
    ],
  },

  // Project 5 - Oracle Cloud : Epm Narrative Reporting Explorer

  {
    title1: 'Oracle Cloud',
    title2: 'Epm Narrative Reporting Explorer',
    image: project5,
    thumbImage: project5_300,
    product: 'Oracle Enterprise Performance Management Cloud',
    ePMBusinessProcess: 'Epm - Narrative Reporting',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '5+',
    noOfSlides: '100+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Understanding Narrative Reporting',
        objectives: [
          'Narrative Reporting - Overview',
          'Narrative Reporting Home Page',
          'Management Report - Overview',
          'Overview of Library',
          'Overview of Artifacts',
        ],
      },

      {
        lessonTitle: 'Overview of Sample Model and Dimensions',
        objectives: ['User Management Tools', 'Understanding Security Basics'],
      },

      {
        lessonTitle: 'Creating Report Package Structure and Adding Content',
        objectives: [
          'Sample Content Overview',
          'Report Package Overview',
          'Report Package Components',
          'Report Center - Overview',
        ],
      },

      {
        lessonTitle: 'Management Reporting - Overview',
        objectives: [
          'Sample Report Package - Overview',
          'Report Designer',
          'Report Objects Overview',
        ],
      },

      {
        lessonTitle: 'Smart View - Basics',
        objectives: [
          'Getting Started with Smart View',
          'Smart View Ad hoc Analysis',
        ],
      },

      {
        lessonTitle: 'Disclosure Management - Basics',
        objectives: [
          'Understanding Disclosure Management',
          'Smart View - Disclosure Management',
        ],
      },

      {
        lessonTitle: 'Become a EPM NR implementer',
        objectives: ['Become a EPM NR implementer'],
      },
    ],
  },

  // Project 6 - Oracle Cloud : Epm Profitability and Cost Management Explorer

  {
    title1: 'Oracle Cloud',
    title2: 'EPM Profitability and Cost Management Explorer',
    image: project6,
    thumbImage: project6_300,
    product: 'EPM Profitability and Cost Management Explorer',
    ePMBusinessProcess: 'EPM -  Profitability and Cost Management',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '5+',
    noOfSlides: '130+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Introduction to PCMCS',
        objectives: [
          'Profitability and Cost Management Cloud - Overview',
          'Profitability and Cost Management Cloud Home Page',
        ],
      },

      {
        lessonTitle: 'Using PCMCS',
        objectives: [
          'Commonly Used Terms',
          'Understanding Security Basics',
          'User Management Tools',
        ],
      },

      {
        lessonTitle: 'About PCMCS Application',
        objectives: [
          'Application Overview',
          'Sample ApplicationBkSLm30',
          'Application Console',
        ],
      },

      {
        lessonTitle: 'About PCMCS Dimensions',
        objectives: ['Dimension Overview', 'Dimension Types'],
      },

      {
        lessonTitle: 'About PCMCS calculation and views',
        objectives: [
          'PCM - Model views',
          'Point of view',
          'PCM Rules Overview',
          'Rule Balancing Screen',
          'Smartview Overview',
          'Allocation Tracking',
        ],
      },

      {
        lessonTitle: 'About PCMCS Rule and Rulesets',
        objectives: [
          'Creating Rules/Rulesets',
          'Model Validation',
          'Rule data validation report (before running rules)',
          'Running Rules and Rulesets',
          'Job Library',
        ],
      },

      {
        lessonTitle: 'Working with Financial Reports',
        objectives: ['Overview'],
      },

      {
        lessonTitle: 'Working with PCMCS Analytics',
        objectives: [
          'Overview of Dashboards',
          'Overview of Profit Curve',
          'Overview of KPIs',
          'Overview of scatter analysis',
          'About analysis view',
        ],
      },

      {
        lessonTitle: 'Continue your learning as an Implementer',
        objectives: ['Become a PCMCS Implementor'],
      },
    ],
  },

  // Project 7 - Administering Oracle WebLogic Server for OKE

  {
    title1: 'Oracle Cloud Infrastructure',
    title2: 'Administering Oracle WebLogic Server for OKE',
    image: project7,
    thumbImage: project7_300,
    product: 'Oracle Cloud Infrastructure',
    ePMBusinessProcess: '',
    OCIComponent: 'Oracle WebLogic Server For OKE',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '8',
    noOfSlides: '200+',
    noOfLabActivities: '15+',

    lessonDetails: [
      {
        lessonTitle:
          'Introduction to Kubernetes and Oracle Cloud Infrastructure',
        objectives: [
          'Introduction to Kubernetes',
          'Oracle Cloud Infrastructure Overview',
        ],
      },

      {
        lessonTitle: 'Components of Oracle WebLogic Server for OKE',
        objectives: [
          'Components Overview',
          'WebLogic Server for OKE',
          'Marketplace',
          'Resource Manager',
          'OCI Container Engine for Kubernetes',
          'Registry',
          'WebLogic Server Kubernetes Operator',
          'Helm',
          'NginX',
          'Jenkins',
          'Vault',
          'Load Balancer',
          'Storage',
        ],
      },

      {
        lessonTitle: 'Prerequisites for Oracle WebLogic Server for OKE',
        objectives: [
          'Pre-Requirement – Mandatory Tasks',
          'Create Compartment',
          'Registry',
          'Create Auth Token',
          'Vault',
          'Oracle Cloud Shell',
          'Secure Shell (SSH) Key Pair',
          'Pre-Requirement - Optional Tasks',
          'Dynamic Group',
          'Policy',
          'Virtual Cloud Network  (VCN)',
          'Database',
        ],
      },

      {
        lessonTitle: 'Create a Domain with Oracle WebLogic Server for OKE',
        objectives: [
          'Oracle Autonomous Transaction Processing (ATP) Database',
          'Create a Basic Domain',
          'Create JRF-Enabled Domain',
        ],
      },

      {
        lessonTitle: 'Access WLS for OKE Domain Resources',
        objectives: [
          'View Associated Resources',
          'Access the WebLogic Console',
          'Access the Administration Instance',
          'Access the Jenkins Console',
        ],
      },

      {
        lessonTitle: 'Jenkins Controller',
        objectives: [
          'Jenkins Overview',
          'Jenkins Controller',
          'Jenkins Pipeline',
          'Pipeline Jobs',
          'Jenkins Deployment Architecture',
        ],
      },

      {
        lessonTitle: 'Manage Domain',
        objectives: [
          'Metrics',
          'Domain Health Check',
          'Start and Stop Servers',
          'Scale a WebLogic Cluster',
          'Session Persistence',
          'Backup and Restore Domain',
          'Destroy Stack Resources and Delete Stack',
        ],
      },

      {
        lessonTitle: 'Troubleshooting Scenarios',
        objectives: [
          'Troubleshooting and Solving Issues',
          'Unable to Access the Console',
          'Stack Creation Failed',
          'Unable to Access Sample Application',
          'Unable to Scale Compute Instances',
          'Load Balancer not Created',
          'Jenkins Installation Failed',
          'Service Limits',
        ],
      },
    ],
  },

  // Project 8 - Oracle Cloud Infrastructure : Administering WebLogic Server on OCI Gen2

  {
    title1: 'Oracle Cloud Infrastructure',
    title2: 'Administering WebLogic Server on OCI Gen2',
    image: project8,
    thumbImage: project8_300,
    product: 'Oracle Cloud Infrastructure',
    ePMBusinessProcess: '',
    OCIComponent: 'WebLogic Server on OCI Gen2',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '8',
    noOfSlides: '240+',
    noOfLabActivities: '15+',

    lessonDetails: [
      {
        lessonTitle: 'Get started with Oracle Cloud Infrastructure',
        objectives: [
          'Oracle Cloud Infrastructure (OCI)',
          'Sign into OCI',
          'List of Services in OCI',
          'OCI Key Concepts',
        ],
      },

      {
        lessonTitle: 'Components of WebLogic Server for OCI',
        objectives: [
          'Oracle WebLogic Server Architecture and Components',
          'WebLogic Server',
          'Marketplace',
          'Resource Manager',
          'Compute',
          'Virtual Cloud Network',
          'Load Balancer',
          'Database',
          'Vault',
          'Identity',
        ],
      },

      {
        lessonTitle: 'Configure Prerequisites for WebLogic Server',
        objectives: [
          'Pre-requirement Tasks for creating Domain',
          'Compartment',
          'Dynamic Group',
          'Policy',
          'Vault',
          'Secure Shell (SSH) Key Pair',
        ],
      },

      {
        lessonTitle: 'Create WebLogic Domain',
        objectives: [
          'Oracle WebLogic Server',
          'Configure WLS Basic Domain',
          'Configure WLS JRF-Enabled Domain',
        ],
      },

      {
        lessonTitle: 'Manage a Domain in Oracle WebLogic for OCI',
        objectives: [
          'Access the WebLogic Console in Public and Private Subnet',
          'Access the Fusion Middleware Control Console',
          'Access Sample Application',
          'Manage Data Sources',
          'Delete a Domain',
        ],
      },

      {
        lessonTitle: 'Secure and Troubleshoot WebLogic Domain',
        objectives: [
          'Configure SSL for a WebLogic Domain',
          'Secure a Domain using Identity Cloud Service',
          'Secure Web Services using Identity Cloud Service',
          'Troubleshot a Domain in WebLogic for OCI',
        ],
      },

      {
        lessonTitle: 'Scale a Domain',
        objectives: [
          'Understanding Scalability',
          'Shapes - Bare Metal Shapes, VM Shapes',
          'Type of Shape',
          'Supported Shapes',
          'Limitations',
          'Steps to Change the Shape',
        ],
      },

      {
        lessonTitle: 'Backup and Restore a  Domain',
        objectives: [
          'Understanding Boot Volume and Block Storage',
          'Understanding Volume Backups – Volume Backup Methods',
          'Restore Block Volume Backup',
          'Repair Boot Volume',
          'Database Backups',
          'Backing Up and Restoring an Autonomous Database Manually',
          'Backing Up a DB System Database',
        ],
      },
    ],
  },

  // Project 9 - Oracle Cloud : Oracle Cloud Overview

  {
    title1: 'Oracle Cloud',
    title2: 'Oracle Cloud Overview',
    image: project9,
    thumbImage: project9_300,
    product: 'Oracle Cloud Overview',
    ePMBusinessProcess: '',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '4',
    noOfSlides: '100+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Cloud Overview',
        objectives: [
          'What is Cloud Computing?',
          'Characteristics of Cloud Computing',
          'Cloud Computing Overview',
          'Service Models & Deployment Models',
          'Benefits of Cloud',
          'Cloud Computing Challenges',
          'Security Challenges on Cloud',
          'Cloud Management and Administration',
          'Cloud Governance',
        ],
      },

      {
        lessonTitle: 'Introduction to Oracle Cloud',
        objectives: [
          'Oracle Cloud Vision',
          'Oracle Cloud Strategy',
          'Oracle Cloud – Key Differentiators',
          'Oracle Cloud Service Portfolio',
          'Relevance of Oracle Cloud to its Stakeholders',
          'Oracle Cloud - Buzzwords and Key Terms',
          'Use cases of Oracle Cloud Computing',
          'Oracle Cloud Security, Shared security model',
          'Pricing Models',
        ],
      },

      {
        lessonTitle: 'Oracle Cloud Solutions',
        objectives: [
          'Oracle Cloud Deployment Choices',
          'Public Cloud',
          'Dedicated Region Cloud@Customer',
          'Customer Use Case Solution',
          'Hybrid Cloud',
          'Oracle Cloud Integration Products',
          'Oracle Cloud Migration Solutions',
          'Migrate to Oracle Cloud',
        ],
      },

      {
        lessonTitle: 'Fundamentals of PaaS',
        objectives: [
          'OCI Gen2 PaaS Services Overview',
          'Development Services',
          'Database Services',
          'Deployment Services',
          'Cloud Observability and Management Services',
          'Analytics Service',
          'Content Management Services',
          'Government Cloud Services',
          'Market Place Services',
        ],
      },
    ],
  },

  // Project 10 - Oracle Cloud : Oracle Cloud Application Developer - Student Learning Subscription

  {
    title1: 'Oracle Cloud',
    title2:
      'Oracle Cloud Application Developer - Student Learning Subscription',
    image: project10,
    thumbImage: project10_300,
    product: 'Cloud Application Developer Student Learning Subscription',
    ePMBusinessProcess: '',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '5',
    noOfSlides: '100+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Introduction To Cloud App Development',
        objectives: [
          'Cloud Computing Overview',
          'What is a Cloud-Based Solution?',
          'Cloud App Development: Key Differences',
          'Benefits of Cloud Apps',
          'Challenges of Cloud-Based Application Development',
          'Tools to Build Cloud-Based Apps',
        ],
      },

      {
        lessonTitle: 'Learning Path Overview ',
        objectives: [
          'Oracle’s Cloud Application Development Platform',
          'Application Development Services',
          'Application Deployment Services',
          'Developer Productivity Services',
        ],
      },

      {
        lessonTitle:
          'Introduction to Oracle Cloud Application Development Platform',
        objectives: [
          'Why Choose Oracle Cloud',
          'Key Features',
          'Types of Developers and Cloud Services',
        ],
      },

      {
        lessonTitle: 'Application Development Services',
        objectives: [
          'Visual Builder Studio',
          'Oracle Mobile Hub',
          'Oracle Digital Assistant',
          'Oracle Blockchain',
        ],
      },

      {
        lessonTitle: 'Application Deployment Services',
        objectives: [
          'Oracle Cloud Infrastructure (OCI)',
          'WebLogic Server for OCI',
          'Microservices and Containers',
          'Container Engine for Kubernetes (OKE)',
          'Developer Productivity Services    Visual Builder Studio',
          'Oracle API Gateway',
        ],
      },
    ],
  },

  // Project 11 - Oracle IoT Cloud : Fleet Monitoring

  {
    title1: 'Oracle IoT Cloud',
    title2: 'Fleet Monitoring',
    image: project11,
    thumbImage: project11_300,
    product: 'Oracle Fleet Monitoring',
    ePMBusinessProcess: '',
    OCIComponent: '',
    ioTCloudApplication: 'Oracle Fleet Monitoring',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '1',
    noOfSlides: '40+',
    noOfLabActivities: '1',

    lessonDetails: [
      {
        lessonTitle: 'Oracle IOT Cloud Fleet Monitoring Overview',
        objectives: [
          'Fleet Monitoring Overview',
          'Configure Fleet Monitoring Application',
          'Design Center',
          'Track and Monitor Fleet Operations',
          'Operation Center',
          'Mobile Application',
        ],
      },
    ],
  },

  // Project 12 - Oracle IoT Cloud: Oracle IoT Cloud Service

  {
    title1: 'Oracle IoT Cloud',
    title2: 'Oracle IoT Cloud Service',
    image: project12,
    thumbImage: project12_300,
    product: 'Oracle IoT Cloud Service',
    ePMBusinessProcess: '',
    OCIComponent: '',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '9',
    noOfSlides: '220+',
    noOfLabActivities: '25+',

    lessonDetails: [
      {
        lessonTitle: 'Getting Started with Oracle IoT Cloud',
        objectives: [
          'Internet of Things (IoT)',
          'Industrial IoT (IIoT)',
          'Application Areas in IoT',
          'Why Oracle for IoT Applications',
          'Oracle IoT - SaaS Applications',
        ],
      },

      {
        lessonTitle: 'Creating and Managing IoT Applications',
        objectives: [
          'Components of Oracle IoT Cloud Service Console',
          'Navigation of Oracle IoT Cloud Service Console',
          'Create, Import, Export, and Delete Applications',
          'Oracle IoT Cloud Service User Roles',
          'Oracle IoT Cloud Service Settings',
          'SaaS Application – Asset Monitoring',
        ],
      },

      {
        lessonTitle: 'Create and Manage Device Models',
        objectives: [
          'IoT Devices',
          'Device Virtualization',
          'A Device Model',
          'Create a New Device Model',
          'How to Define System and Custom attributes',
          'How to Add Actions',
          'How to Add Alert and Custom Data Message',
          'Manage a Device Model',
          'Edit, Duplicate, Import, Export, Print',
        ],
      },

      {
        lessonTitle: 'Register and Activate Devices',
        objectives: [
          'Need for Device Registration',
          'Device Life Cycle',
          'Device Property',
          'Device Registration',
          'Registering a Single Device',
          'Batch Registration using a CSV file',
          'Activate a Device',
          'View the Devices Associated with a Device Model',
        ],
      },

      {
        lessonTitle: 'Manage Devices',
        objectives: [
          'Locate a Device and Customize Device View',
          'Manage Devices',
          'Describe Device Selection',
          'Describe Device Exploration',
          'Discuss the Use Case – Managing Devices Truck Simulator',
        ],
      },

      {
        lessonTitle:
          'Develop Device Application Using Client Software Libraries',
        objectives: [
          'Client Software Libraries',
          'Directly Connected and Indirectly Connected Devices',
          'Data Stream and Messages',
          'Create Device Application Using Client JavaScript Libraries',
        ],
      },

      {
        lessonTitle: 'Create and Manage Connectors',
        objectives: [
          'Connectors',
          'Connection Methods',
          'Configure Built-In Connectors',
          'Describe Grammars',
          'Configure Interpreters',
        ],
      },

      {
        lessonTitle: 'Implement Digital Twin Simulator',
        objectives: [
          'Digital Twin Framework',
          'Capabilities of Digital Twin Framework',
          'Methods to Implement Digital Twin Framework',
          'IoT Digital Twin Simulator',
          'Simulator Device Models',
          'How to Manage Simulator Device Models',
          'Simulated Devices',
          'How to Manage Simulated Devices',
        ],
      },

      {
        lessonTitle: 'Create and Manage Explorations',
        objectives: [
          'Data Exploration',
          'Data Exploration Page View',
          'Data Exploration',
          'Exploration Source',
          'Message, Database, Map',
          'Exploration',
          'Source',
          'Pattern',
        ],
      },
    ],
  },

  // Project 13 - Oracle IoT Cloud : Oracle IoT Asset Monitoring

  {
    title1: 'Oracle IoT Cloud Service',
    title2: 'Oracle IoT Asset Monitoring',
    image: project13,
    thumbImage: project13_300,
    product: 'Oracle IoT Cloud Service',
    ePMBusinessProcess: '',
    OCIComponent: '',
    ioTCloudApplication: 'Oracle IoT Asset Monitoring',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '5',
    noOfSlides: '115+',
    noOfLabActivities: '9',

    lessonDetails: [
      {
        lessonTitle: 'Getting Started with IoT Asset Monitoring',
        objectives: [
          'What is IoT Asset Monitoring Cloud Service',
          'Operations Center',
          'Design Center',
          'Building Blocks of Oracle IoT Asset Monitoring Cloud Service',
          'Organizations',
          'Groups',
          'Oracle IoT Asset Monitoring user interfaces',
          'Asset Type',
          'Asset Inventory',
        ],
      },

      {
        lessonTitle: 'Configure IoT Asset Monitoring Simulator',
        objectives: [
          'Create and Manage a Place',
          'Create Asset Associations',
          'Define Simulations for Sensor Attributes',
          'Define Simulations for Sub-Asset Type',
          'Create Simulated Actions',
          'Create Asset Metrics',
        ],
      },

      {
        lessonTitle: 'Integrate Oracle Mobile Hub with Oracle IoT Cloud',
        objectives: [
          'Oracle IoT Cloud Integration',
          'Steps to Integrate Oracle IoT Cloud with Oracle Mobile Hub:',
          'Sign in to OMH',
          'Create Backend, Storage, Collections',
          'Select the API',
          'Sign in to Management Console of IoT Cloud Service',
          'Create Integration',
          'Verify Data Flow from IoT Cloud to Mobile Hub',
        ],
      },

      {
        lessonTitle: 'Integrate Oracle IoT Cloud with Oracle Integration',
        objectives: [
          'Steps to Integrate Oracle IoT Cloud with Oracle Integration Cloud (OIC)',
          'Sign into OIC',
          'Create Connection, Integration, Trigger and Invoke',
          'Create Mappings and Tracking',
          'Select the Endpoint URL',
          'Sign into Management Console of IoT Cloud service',
          'Create Integration',
          'Verify Data Flow from IoT Cloud to OIC',
        ],
      },

      {
        lessonTitle: 'Integrate Oracle IoT Cloud Data With Analytics Cloud',
        objectives: [
          'Data Integration Steps Between Oracle IoT Cloud and Analytics Cloud',
        ],
      },
    ],
  },

  // Project 14 - Oracle Cloud : Agile Development With Oracle Developer Cloud Service

  {
    title1: 'Oracle Cloud',
    title2: 'Agile Development with Oracle Developer Cloud Service',

    image: project14,
    thumbImage: project14_300,
    product: 'Oracle Developer Cloud Service',
    ePMBusinessProcess: '',
    OCIComponent: '',
    ioTCloudApplication: '',
    oracleCloud: 'Agile Development with Oracle Developer Cloud Service',

    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '10+',
    noOfSlides: '450+',
    noOfLabActivities: '4',

    lessonDetails: [
      {
        lessonTitle: 'Agile and Cloud Computing Overview',
        objectives: [
          'Agile Methodology and Cloud Computing Overview',
          'Steps to Sign into Oracle Cloud',
          'How Developer Cloud Service Works',
          'Version, Source Code Management and How Git is Implemented in Oracle DevCs',
          'Implement Project Maven Repository in Oracle DevCs',
          'Using Snippets and Issue Tracking Tools in DevCs',
          'How to Use the Agile Methodology in DevCs',
          'Using Wiki Pages and Implementing IDE’s in DevCs',
          'Managing Project Jobs, Builds and Deploying Applications in DevCs',
        ],
      },

      {
        lessonTitle: 'Sign Into Oracle Cloud',
        objectives: [
          'Describe Oracle Cloud Accounts',
          'List the Types of Cloud Subscriptions',
          'Steps to Subscribe to an Oracle Cloud Service Trial License',
          'Sign into Oracle Cloud',
          'My Services Dash Board',
          'Oracle Cloud User Roles and Privileges',
        ],
      },

      {
        lessonTitle: 'Creating Developer Cloud Service Instance',
        objectives: [
          'Navigating to Oracle Developer Cloud Service',
          'Creating Oracle Developer Cloud Service Instance',
          'Configure Connection to Oracle Cloud Infrastructure Compute Classic and Object Storage Classic',
        ],
      },

      {
        lessonTitle: 'Oracle Developer Cloud Service Overview',
        objectives: [
          'Overview and Architecture of Oracle Developer Cloud Services',
          'Creating a New Project',
          'Setting up User Preferences – Profile',
          'Create Environment & Instances',
        ],
      },

      {
        lessonTitle:
          'Implementing Agile Methodology in Oracle Developer Cloud Service',
        objectives: [
          'Agile Components Overview',
          'Describe the Key Components of the Agile Page',
          'Create Issue and Manage Boards on the Agile Page',
          'Create and Manage Sprints and Issues',
          'Use Charts and Reports in the Reports View',
        ],
      },

      {
        lessonTitle: 'Using Git in Oracle Developer Cloud Service',
        objectives: [
          'Describe Version Control',
          'Use Git in Oracle Developer Cloud Service',
          'Clone Oracle Developer Cloud Service Project Git Repository to Local Machine',
        ],
      },

      {
        lessonTitle: 'Define, Configure Project Template',
        objectives: [
          'Defining a  Project Template',
          'Setting Visibility Properties',
          'Managing Rules',
          'Adding Variables',
          'Manage Project Announcements',
          'Manage Project Tags',
        ],
      },

      {
        lessonTitle:
          'Using Snippets and Wiki Pages in Oracle Developer Cloud Service',
        objectives: [
          'Create and Manage Snippets',
          'Create and Manage Wiki Pages',
        ],
      },

      {
        lessonTitle:
          'Using a Project Maven Repository in Oracle Developer Cloud Service',
        objectives: [
          'Describe a Project Maven repository',
          'Project Object Model(POM)',
          'Managing Artifacts in Maven - Developer Cloud service',
          'Using the Maven Command - Line Interface',
          'Maven Repository Administration',
        ],
      },

      {
        lessonTitle: 'Using IDEs with Oracle Developer Cloud Service',
        objectives: [
          'Use the Eclipse IDE with Oracle Developer Cloud Service',
          'Use the NetBeans IDE with Oracle Developer Cloud Service',
          'Use Oracle JDeveloper with Oracle Developer Cloud Service',
        ],
      },

      {
        lessonTitle:
          'Managing Project Jobs and Builds in Oracle Developer Cloud Service',
        objectives: [
          'Understanding “Build” Process',
          'Build VM and a Build VM Template',
          'Workflow of Job and Build',
          'Set Up the Build System',
          'Build Page Overview',
          'Creating and Configuring a Job',
          'Run a Build',
        ],
      },

      {
        lessonTitle: 'Using Merge Requests to Review Code',
        objectives: [
          'Describe Code Review Basics',
          'Create and Manage a New Branch for Review',
          'Merge a Review Branch with a Target Branch',
        ],
      },

      {
        lessonTitle: 'Deploying an Application',
        objectives: [
          'Deployment - Overview',
          'Deployment Concepts and Terms',
          'Deployment -  Prerequisite',
          'Deploy an Application to',
          'Oracle Java Cloud Service(JCS)',
          'Oracle Java Cloud Service – SaaS Extension(JCS-SX)',
          'Oracle Application Container Cloud Service(ACCS)',
          'Examine Deployment Logs',
        ],
      },
    ],
  },

  // Project 15 - Oracle Cloud : Java IoT Developer

  {
    title1: 'Oracle Cloud',
    title2: 'Java IoT Developer',

    image: project15,
    thumbImage: project15_300,
    product: 'Java IoT Developer',
    ePMBusinessProcess: '',
    OCIComponent: '',
    ioTCloudApplication: 'Java IoT Developer',
    project:
      'Technical Learning Content Development for INClass and Online Learning',
    client: 'Oracle University',
    deliverables: 'Video, Learning Content, Lab Activity Guide',
    noOfLessons: '20+',
    noOfSlides: '650+',
    noOfLabActivities: '',

    lessonDetails: [
      {
        lessonTitle: 'Course Introduction',
        objectives: [
          'Internet of Things (IoT)',
          'Architecture and Application Areas of IoT',
          'Developing and Deploying Java Embedded Applications to Raspberry Pi',
          'Raspberry Pi Microcontroller',
          'Different Sensors Used in IoT Applications',
          'Java Embedded Programming - Java ME 8.3',
          'Cloud Computing',
          'Oracle IoT Cloud services',
          'Programming Raspberry Pi – Python (Optional)',
        ],
      },

      {
        lessonTitle: 'Getting Started with Internet of Things',
        objectives: [
          'Describe the Brief History of IoT',
          'Explain IoT (Internet of Things)',
          'Explain Definition of “Things”',
          'Describe the Attributes of Things',
          'Explain WoT Terminology',
          'Describe Technology Road Map of Internet of Things',
        ],
      },

      {
        lessonTitle: 'Setting Up Development Environment for IoT',
        objectives: [
          'Java Development Kit (JDK) SE 8',
          'Oracle Java ME SDK 8',
          'Net Beans 8 IDE',
          'Oracle Java ME SDK 8 Plug-in for Net Beans',
          'Python Compiler',
          'Python Plug-in for Net Beans',
        ],
      },

      {
        lessonTitle: 'Getting Started - Java, NetBeans IDE and Raspberry Pi',
        objectives: [
          'Explain How to Build Simple Java Program',
          'Describe NetBeans',
          'Begin Working with Java, NetBeans IDE and Raspberry Pi',
          'Build Java ME 8 Projects and Run the Program',
          'Viewing the Output in Emulator and Putty Screen (which is connected to Raspberry Pi)',
        ],
      },

      {
        lessonTitle: 'IoT Architecture',
        objectives: [
          'Devices & Gateway – How they exist Today',
          'Logical End-to-End View of IoT Architecture',
          'Internet of Things – Three Layers of Architecture',
          'Oracle Internet of Things Cloud Service – Overview',
          'IoT Device Management',
          'Different Components of Oracle IoT Cloud Service',
          'Device Virtualization',
        ],
      },

      {
        lessonTitle: 'Raspberry Pi Basics',
        objectives: [
          'History of Raspberry Pi',
          'Details of Raspberry Pi Board',
          'Hardware Accessories Required to Build a Raspberry Pi project',
          'GPIO Pin Configurations',
          'Other Microcontroller Boards',
          'About Arduino Board',
          'About Intel Galileo Development Board',
          'About STM32F746G Discovery Kit',
          'Different Microcontroller Boards Used in IoT',
        ],
      },

      {
        lessonTitle: 'Deep Dive into Java ME 8 for IoT',
        objectives: [
          'Java Platform, Standard Edition (Java SE) , Enterprise Edition (Java EE), Micro Edition (Java ME)',
          'Embedded Programming',
          'Java Card, Java ME Embedded, Java SE Embedded',
          'Java ME 8 Platform Overview',
          'Java Platform, APIs, Optional Packages, Embedded APIs Embedded  8.3',
          'Java ME Configurations',
          'Java ME 8: A Service-Enabled Platform',
          'Java ME 8: Oracle Product Strategy',
          'The Development Platform for our Lab',
        ],
      },

      {
        lessonTitle: 'Setting Up Software Components on Raspberry Pi',
        objectives: [
          'Setting Up Software Components on Raspberry Pi',
          'Setting Up components for Raspberry Pi',
          'Prerequisite Gathering',
          'Formatting SD Card',
          'Downloading and Installing Raspbian Image',
          'Configuring Raspberry Pi',
          'First Time Boot – Initial Configurations',
          'Configuring Raspbian on Raspberry Pi Board',
        ],
      },

      {
        lessonTitle: 'Building Java ME IMlets Programs for IoT',
        objectives: [
          'Describe the IMlet',
          'Describe the Life Cycle of an IMlet',
          'Identify the Roles of Java Application Descriptor (JAD) and Java Archive (JAR) files',
          'Overview of Security Model and Oracle Java ME Embedded Permissions',
          'Describe the Over-The-Air (OTA) Installation Process',
        ],
      },

      {
        lessonTitle: 'Sensors Overview',
        objectives: [
          'Describe What is Sensor?',
          'Describe Sensors in Everyday Life',
          'Describe the Types of Sensors Used in Smart Phone',
          'Describe Sensor Devices And GPIO Pins: Schematic Diagram',
          'Describe the GPIO PIN Configuration',
        ],
      },

      {
        lessonTitle: 'Digital and Analog Sensors',
        objectives: [
          'Describe the Role of Sensors in IoT',
          'Describe the Types of Sensors Used in IoT',
          'Describe Digital Sensor',
          'Describe Analog Sensor',
          'Provide an Overview of Device IO API',
        ],
      },

      {
        lessonTitle: 'CLDC Overview',
        objectives: [
          'Identify the CLDC Versions and their Features',
          'Identify the Available Collections',
          'Work with Common Collections',
          'Describe the CLDC Streams',
          'Design and Create Threads by Using Thread or Runnable',
          'Design and Create Tasks That are Run at a Scheduled Rate',
        ],
      },

      {
        lessonTitle: 'Accessing Sensors - Device I/O API',
        objectives: [
          'What is a Device API?',
          'Use of Device Access API',
          'Read and Write General Purpose I/O (GPIO) Pins and Ports',
          'Control Inter-Integrated Circuit (I2C) Devices',
          'Control Universal Asynchronous Receiver/Transmitter (UART) Devices',
          'Accessing Devices Using Generic I/O Operations ( jdk.dio.generic )',
          'Use a Watchdog Timer to Control System Hangs',
        ],
      },

      {
        lessonTitle: 'Using the Logging API',
        objectives: [
          'Use the Java ME SDK  Logging Service to Record Runtime Execution Information',
          'Create the Following:',
          'A Handler to Export Messages',
          'A Formatter to Modify Message Presentation',
          'A Filter to Choose Which Messages to Log',
        ],
      },

      {
        lessonTitle: 'Generic Connection Framework (GCF)',
        objectives: [
          'Provide an Overview of GCF – JSR 360',
          'Describe New Features of GCF – CLDC',
          'Describe GCF Classes and Interface',
          'Code Examples',
          'Send and Receive Short Message Service (SMS) messages',
        ],
      },

      {
        lessonTitle: 'Application Management System (AMS)',
        objectives: [
          'Provide an Overview of the Application Management System (AMS)',
          'Describe Different Ways of Using the Java Runtime on the Raspberry Pi Board',
          'Running IMlets on the Raspberry Pi Using the Command Shell',
          'Running Application Management System (AMS) Using Developer Agent program',
          'List AMS CLI commands',
        ],
      },

      {
        lessonTitle: 'Creating Notifications with Push Registry',
        objectives: [
          'Describe the Push Registry Mechanism',
          'Identify Use Cases for the Push Registry',
          'Describe the Different Types of Push Registry Triggers, Including Alarms and Connections',
          'Register an Alarm',
          'Register a Connection',
        ],
      },

      {
        lessonTitle: 'Storing Data by Using the Record Management System',
        objectives: [
          'Describe the Record Management System (RMS) and the Differences Between it and a Traditional File System',
          'Identify the Structure of the RMS',
          'Create a RecordStore and Save Data in it',
          'Read Data From an Existing RecordStore',
        ],
      },

      {
        lessonTitle: 'Cloud Overview',
        objectives: [
          'Cloud Computing',
          'NIST (National Institute of Standards and Technology) of Cloud Computing',
          'The Essential Characteristics of Cloud Computing',
          'Different Service Models of Cloud Computing',
          'Different Deployment Models of Cloud Computing',
          'Oracle Cloud',
        ],
      },

      {
        lessonTitle: 'Oracle IoT Cloud Services Overview',
        objectives: [
          'Oracle IoT Cloud',
          'Oracle IoT Cloud Architecture',
          'Different Layers of Oracle IoT Cloud',
          'Services in Oracle IoT Cloud',
        ],
      },

      {
        lessonTitle:
          'Solving Logistics Challenge Using IoT – Case Study Part 1',
        objectives: [
          'How to Get Started with the Hardware',
          'Working with GPIO on the Raspberry Pi',
          'I2C Overview',
          'Enabling I2C on the Raspberry Pi',
          'I2C the Code',
        ],
      },

      {
        lessonTitle:
          'Solving Logistics Challenge Using IoT – Case Study Part 2',
        objectives: [
          'UART Serial Protocol Overview',
          'GPS Overview',
          'Connecting the GPS Sensor Using a USB UART Cable',
          'Connecting the GPS Directly to the Raspberry Pi UART',
          'Reading GPS Data in a Java ME 8 Embedded application',
          'Saving GPS Data in the Record Management Store',
          'Saving GPS Data in a File',
          'Auto-Restarting the AMS and IMlets (Power-On Restarts)',
        ],
      },
    ],
  },
];

export default projectsData;
